import { roleRoutes } from "utils/roles";
import { useAuthToken } from "../../providers/authProviders";
import { Navigate } from "react-router-dom";

/**
 * Permite el paso SOLO al superadministrador del sistema (systemSuperadmin,
 * la plataforma completa). A diferencia de RequireAdmin —que admite admin,
 * superadmin logístico, support y supervisor— este guard restringe la ruta a
 * ese único rol. Se usa para páginas de plataforma como "Salud IA"
 * (/admin/ai-health), cuyo hogar es superadmin.
 *
 * Los demás perfiles admin-ish (autenticados, pero sin este permiso) se
 * redirigen a /admin en vez de al login para no rebotarlos fuera del panel.
 */
export default function RequireSystemSuperadmin({ children }) {
  const { isAuthenticated, role } = useAuthToken();

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  if (role !== roleRoutes.systemSuperadmin) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
